import { useQuery } from "@tanstack/react-query";
import { SitemapVersionLevelStatus } from "@iventis/domain-model/model/sitemapVersionLevelStatus";
import { CadStyle } from "@iventis/cad-georeferencer/src/types/style";
import { useSitemapApiContext } from "../context/sitemap-api-context";
import { useSitemapRoutingContext } from "../context/sitemap-routing-context";
import { SitemapVersionLevelWithFiles } from "../sitemap-types";

const SITEMAP_VERSION_LEVEL_CAD_FILES_KEY = "sitemap-version-level-cad-files";

export function useSitemapVersionLevelCadFiles(sitemapVersionLevel: SitemapVersionLevelWithFiles): { style: CadStyle } {
    const { getSelectedSitemapId } = useSitemapRoutingContext();
    const { getSitemapVersionLevelCadFiles } = useSitemapApiContext();

    const { data } = useQuery([SITEMAP_VERSION_LEVEL_CAD_FILES_KEY, sitemapVersionLevel?.id], {
        queryFn: () => getSitemapVersionLevelCadFiles(getSelectedSitemapId(), sitemapVersionLevel.sitemapVersionId, sitemapVersionLevel.id),
        enabled: sitemapVersionLevel != null && sitemapVersionLevel.status === SitemapVersionLevelStatus.Reviewing,
    });

    return { style: data?.style };
}
